import { NextPage, NextPageContext } from 'next';

import { EProductsId } from '@r1-frontend/shared/types/EProductsId';

import { EShopCategory } from '~/src/api/content/shop/getShopItems';
import ItemDetailPage from '~/src/features/equipment/shop/[itemId]';
import { getItemDetailsInitialProps, TEquipmentDetailsProps } from '~/src/features/equipment/shop/helpers';

const RouterDetailPage: NextPage<TEquipmentDetailsProps> = (props) => <ItemDetailPage productId={EProductsId.internet} {...props}/>;

RouterDetailPage.getInitialProps = (ctx: NextPageContext) => getItemDetailsInitialProps(ctx, {
    category: EShopCategory.Routers,
    basePath: '/internet/equipment',
});

export default RouterDetailPage;
